<template>
    <b-modal v-if="!loading" id="supplier_form" ref="supplier_form"
             @hidden="resetForm" no-close-on-backdrop
             modal-class="modal-right modal-dialog-scrollable">
        <template v-slot:modal-title>
            {{ !edit ? 'Add Supplier' : 'Edit Supplier' }}
        </template>

        <div class="d-flex flex-row mb-4">
            <span class="iconsminds-add mr-3 menu-icon-style"/>

            <p class="my-auto">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi
                dolores quod, repellendus similique sint.
            </p>
        </div>

        <b-form>
            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Code" class="has-float-label">
                        <template v-slot:label>
                            <span>Code <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.code" :class="{'border-danger': 'code' in errors}"
                                      @input="'code' in errors ? delete errors.code : ''"
                                      autocomplete="off" placeholder="Code"/>

                        <b-form-invalid-feedback :state="!'code' in errors"
                                                 v-text="'code' in errors ? errors.code[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Company" class="has-float-label">
                        <template v-slot:label>
                            <span>Company <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.company" :class="{'border-danger': 'company' in errors}"
                                      @input="'company' in errors ? delete errors.company : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'company' in errors"
                                                 v-text="'company' in errors ? errors.company[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="DBA" class="has-float-label">
                        <template v-slot:label>
                            <span>DBA <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.dba" :class="{'border-danger': 'dba' in errors}"
                                      @input="'dba' in errors ? delete errors.dba : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'dba' in errors"
                                                 v-text="'dba' in errors ? errors.dba[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="EIN" class="has-float-label">
                        <template v-slot:label>
                            <span>EIN <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.ein" :class="{'border-danger': 'ein' in errors}"
                                      @input="'ein' in errors ? delete errors.ein : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'ein' in errors"
                                                 v-text="'ein' in errors ? errors.ein[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Opening Balance" class="has-float-label">
                        <template v-slot:label>
                            <span>Opening Balance <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.opening_balance" :class="{'border-danger': 'opening_balance' in errors}"
                                      @input="'opening_balance' in errors ? delete errors.opening_balance : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'opening_balance' in errors"
                                                 v-text="'opening_balance' in errors ? errors.opening_balance[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Address" class="has-float-label">
                        <template v-slot:label>
                            <span>Address <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.address" :class="{'border-danger': 'address' in errors}"
                                      @input="'address' in errors ? delete errors.address : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'address' in errors"
                                                 v-text="'address' in errors ? errors.address[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="City" class="has-float-label">
                        <template v-slot:label>
                            <span>City <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.city" :class="{'border-danger': 'city' in errors}"
                                      @input="'city' in errors ? delete errors.city : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'city' in errors"
                                                 v-text="'city' in errors ? errors.city[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="6">
                    <b-form-group label="State" class="has-float-label">
                        <template v-slot:label>
                            <span>State <sup><code>*</code></sup></span>
                        </template>

                        <v-select @input="updateState" v-model="selected.state" :options="states"
                                  :border-danger="'state_id' in errors"/>

                        <b-form-invalid-feedback :state="!('state_id' in errors)"
                                                 v-text="'state_id' in errors ? errors.state_id[0] : ''"/>
                    </b-form-group>
                </b-colxx>

                <b-colxx md="6">
                    <b-form-group label="ZIP" class="has-float-label">
                        <template v-slot:label>
                            <span>ZIP <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-mask="'#####'" :class="{'border-danger': 'zip' in errors}"
                                      @input="'zip' in errors ? delete errors.zip : ''"
                                      v-model="form.zip" placeholder="XXXXX" autocomplete="off"/>

                        <b-form-invalid-feedback :state="!'zip' in errors"
                                                 v-text="'zip' in errors ? errors.zip[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Contact Person" class="has-float-label">
                        <template v-slot:label>
                            <span>Contact Person <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.contact_person" :class="{'border-danger': 'contact_person' in errors}"
                                      @input="'contact_person' in errors ? delete errors.contact_person : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'contact_person' in errors"
                                                 v-text="'contact_person' in errors ? errors.contact_person[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Phone" class="has-float-label">
                        <template v-slot:label>
                            <span>Phone <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.phone" :class="{'border-danger': 'phone' in errors}"
                                      @input="'phone' in errors ? delete errors.phone : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'phone' in errors"
                                                 v-text="'phone' in errors ? errors.phone[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="Fax" class="has-float-label">
                        <template v-slot:label>
                            <span>Fax <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.fax" :class="{'border-danger': 'fax' in errors}"
                                      @input="'fax' in errors ? delete errors.fax : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'fax' in errors"
                                                 v-text="'fax' in errors ? errors.fax[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12">
                    <b-form-group label="E-mail" class="has-float-label">
                        <template v-slot:label>
                            <span>E-mail <sup><code>*</code></sup></span>
                        </template>

                        <b-form-input type="text" v-model="form.email" :class="{'border-danger': 'email' in errors}"
                                      @input="'email' in errors ? delete errors.email : ''"
                                      autocomplete="off" placeholder="Name"/>

                        <b-form-invalid-feedback :state="!'email' in errors"
                                                 v-text="'email' in errors ? errors.email[0] : ''"/>
                    </b-form-group>
                </b-colxx>
            </b-row>

            <b-row>
                <b-colxx md="12" class="mb-4">
                    <b-form-group label="Notes" class="has-float-label">
                        <b-form-textarea v-model="form.notes" rows="6" placeholder="Notes"/>
                    </b-form-group>
                </b-colxx>
            </b-row>
        </b-form>
        <template slot="modal-footer">
            <b-button variant="outline-secondary" @click="hideModal('supplier_form')" v-text="'Cancel'"/>

            <state-button v-if="!edit" variant="primary" :click="submitSupplier">Submit</state-button>

            <state-button v-else variant="primary" :click="updateSupplier">Update</state-button>
        </template>
    </b-modal>
</template>

<script>

import {mapGetters} from "vuex";
import StateButton from "../../../../../components/Common/StateButton";

export default {
    name: "SupplierFormModal",

    components: {
        StateButton,
    },

    props: [
        'edit'
    ],

    data() {
        return{
            loading: true,
            selected: {
                state: [],
            },
        }
    },

    computed: {
        ...mapGetters({
            form: 'getSupplierForm',
            errors: 'getSupplierErrors',
            states: 'getSelectInventoryStates',
        })
    },

    mounted() {
        this.getFormData();
    },

    methods: {
        resetForm() {
            this.$store.commit('setSupplierForm');

            this.selected.supplier = [];
        },

        updateState(field) {
            if (field) {
                this.form.state_id = field.state_id;
            } else {
                this.form.state_id = '';
            }
            'state_id' in this.errors ? delete this.errors.state_id : '';
        },

        hideModal(refname) {
            this.$refs[refname].hide();
        },

        async getFormData() {
            await this.$store.dispatch('fetchSelectInventoryStates');

            return this.loading = false;
        },

        submitSupplier() {
            return new Promise((success, fail) => {
                this.$store.dispatch('submitSupplier', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Added new Supplier!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('supplier_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },

        updateSupplier() {
            return new Promise((success, fail) => {
                this.$store.dispatch('updateSupplier', this.form)
                    .then(response => {
                        setTimeout(() => {
                            success();

                            this.$emit('updated');

                            this.resetForm();

                            this.$notify('success filled', 'Success!', 'Updated the supplier!', {
                                duration: 4000,
                                permanent: false
                            });

                            this.hideModal('supplier_form');
                        }, 2000);
                    })
                    .catch(error => {
                        setTimeout(() => {
                            fail();
                        }, 1000);
                    });
            })
        },
    }
}
</script>

<style scoped>

</style>
